export default (state: boolean = false, { payload, type }: { payload: boolean, type: string }) => {
  switch (type) {
    case 'SET_LOGGED_IN':
      return payload;

    default:
      return state;
  }
};